import { useEffect, useState, useContext, useRef } from "react"
import axios from "axios"
import { useParams, useNavigate } from "react-router-dom"
import { Box, Button, Center, Heading, Text, useToast } from "@chakra-ui/react"
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"
import { addDoc, collection, getDocs, where, query } from "firebase/firestore"
import { UserContext } from "../../Contexts/UserContext"
import { db, storage } from "../../firebase"
import config from "../../config.js"
import { JobRequestResponseJobDetailsAccordion } from "../../Components/JobRequestResponseJobDetailsAccordion"
import { FileUpload } from "../../Components/FileUpload"

export const JobRequestCompletion = () => {
	const toast = useToast()
	const navigate = useNavigate()
	const { id } = useParams()
	const { userPlus } = useContext(UserContext)
	const [jobRequestResponse, setJobRequestResponse] = useState(null)
	const [jobRequest, setJobRequest] = useState(null)
	const [formData, setFormData] = useState({
		files: [],
	})

	const toastShown = useRef(false)

	useEffect(() => {
		if (!id) {
			return
		} else {
			const getJobRequestResponse = async () => {
				const q1 = query(collection(db, "jobRequests"), where("id", "==", id))
				const docSnap1 = await getDocs(q1)
				if (!docSnap1.empty) {
					setJobRequest(docSnap1.docs[0].data())
				}

				const q = query(
					collection(db, "jobRequestResponses"),
					where("requestId", "==", id)
				)
				const docSnap = await getDocs(q)
				if (!docSnap.empty) {
					setJobRequestResponse(docSnap.docs[0].data())
				} else {
					// Only show toast if it hasn't been shown yet
					if (!toastShown.current) {
						toast({
							title:
								"You need to respond to the job request before uploading completed photos.",
							status: "error",
							duration: 6000,
							isClosable: true,
						})
						toastShown.current = true
						navigate(`/job-request/${id}`)
					}
				}
			}
			getJobRequestResponse()
		}
	}, [id])

	const uploadToFirebase = async (file, responseId) => {
		const storageRef = ref(
			storage,
			`jobRequestCompletion/${responseId}-${crypto.randomUUID()}`
		)

		try {
			const snapshot = await uploadBytes(storageRef, file)
			const downloadURL = await getDownloadURL(snapshot.ref) // Get file URL
			return downloadURL // Return file URL
		} catch (error) {
			console.error("File upload failed:", error)
			return null
		}
	}

	const onSubmit = async () => {
		const uploadedFilePaths = []
		for (const file of formData.files) {
			const filePath = await uploadToFirebase(file, jobRequestResponse.id) // Upload file and get its path
			if (filePath) {
				uploadedFilePaths.push(filePath)
			}
		}
		if (uploadedFilePaths.length > 0) {
			await addDoc(collection(db, "jobRequestCompletion"), {
				id: crypto.randomUUID(),
				_createdAt: new Date(),
				vendorId: userPlus.id,
				jobRequestId: id,
				jobRequestResponseId: jobRequestResponse.id,
				completionFiles: uploadedFilePaths,
			})
			if (jobRequest.partner === "BDPS") {
				await axios.post(
					`${config.baseURL}/api/blackdome-document-upload-notification`,
					{
						vendorName: userPlus.name,
						jobRequestResponse,
						jobRequest,
						userEmail: jobRequest.userEmail,
						documentType: "Completed Photos",
						uploadedFiles: uploadedFilePaths,
					}
				)
			} else {
				await axios.post(`${config.baseURL}/api/document-upload-notification`, {
					vendorName: userPlus.name,
					jobRequestResponse,
					jobRequest,
					userEmail: jobRequest.userEmail,
					documentType: "Completed Photos",
					uploadedFiles: uploadedFilePaths,
				})
			}
			navigate("/job-requests")
		} else {
			alert("Please upload a file.")
		}
	}

	return (
		<Center
			flexDirection="column"
			maxW="629px"
			margin={{ base: "15px", md: "auto" }}
			gap={3}
		>
			<Box w="100%" mb={4}>
				<Heading size="lg" fontWeight="bold" my={4}>
					Add Completed Photos
				</Heading>
				<Text mb={4}>
					Share completed photos with the client. Clients will receive an email
					notification.
				</Text>
				<JobRequestResponseJobDetailsAccordion jobRequest={jobRequest} />
			</Box>
			<FileUpload formData={formData} setFormData={setFormData} />
			<Button
				onClick={onSubmit}
				isDisabled={formData.files.length === 0}
				w="100%"
				bgColor="borderColor"
				color="white"
				mt="40px"
				mb="40px"
			>
				Submit
			</Button>
		</Center>
	)
}
